import createReducer, { ActionCreatorHelper } from '@hh.ru/redux-create-reducer';

export interface InitialExperimentsState {
    checked: string[];
    enabled: Record<string, string>;
}

export const CHECK_EXPERIMENT = 'CHECK_EXPERIMENT';

interface PayloadTypes {
    [CHECK_EXPERIMENT]: string;
}

const actionCreator = ActionCreatorHelper<PayloadTypes>();
export const addCheckedExp = actionCreator(CHECK_EXPERIMENT);

export const INITIAL_STATE: InitialExperimentsState = {
    checked: [],
    enabled: {},
};

export const experimentsReducer = createReducer<InitialExperimentsState, PayloadTypes>(INITIAL_STATE, {
    [CHECK_EXPERIMENT]: (state, { payload }) => ({
        ...state,
        checked: [...state.checked, payload],
    }),
});
